import {
  FiCreditCard,
  FiDollarSign,
  FiFileText,
  FiLayers,
  FiMessageSquare,
  FiBookOpen,
} from "react-icons/fi";
import type { IconType } from "react-icons";

export interface AccessGrantDefinition {
  key: string;
  label: string;
  description: string;
  icon: IconType;
}

export const ACCESS_GRANT_DEFINITIONS: AccessGrantDefinition[] = [
  {
    key: "requests:all",
    label: "همه درخواست‌ها",
    description: "بدون فیلتر مالکیت به همه درخواست‌ها دسترسی دارد.",
    icon: FiFileText,
  },
  {
    key: "transactions:all",
    label: "همه تراکنش‌ها",
    description: "می‌تواند همه تراکنش‌ها را ببیند و مدیریت کند.",
    icon: FiDollarSign,
  },
  // {
  //   key: "paymentBatchCards:all",
  //   label: "همه بسته‌های کارت هدیه",
  //   description: "همه بسته‌های کارت هدیه را بدون محدودیت مالکیت می‌بیند.",
  //   icon: FiLayers,
  // },
  // {
  //   key: "paymentCards:all",
  //   label: "همه کارت‌های هدیه",
  //   description: "همه کارت‌های هدیه را بدون فیلتر مشاهده و مدیریت می‌کند.",
  //   icon: FiCreditCard,
  // },
  {
    key: "paymentSlips:all",
    label: "همه فیش‌های پرداخت",
    description: "به همه فیش‌های پرداخت ثبت‌شده دسترسی دارد.",
    icon: FiFileText,
  },
  // {
  //   key: "news:all",
  //   label: "همه خبرها",
  //   description: "به همه خبرها در بخش مدیریت دسترسی کامل دارد.",
  //   icon: FiBookOpen,
  // },
  // {
  //   key: "messages:all",
  //   label: "همه پیام‌ها",
  //   description: "همه پیام‌ها را بدون محدودیت مخاطب یا سازنده می‌بیند.",
  //   icon: FiMessageSquare,
  // },
];

export const ACCESS_GRANT_LABEL_MAP = Object.fromEntries(
  ACCESS_GRANT_DEFINITIONS.map((item) => [item.key, item.label]),
);
